import Plot from 'react-plotly.js';

const getHistogramValues = (selectedDataKey,data) => {
  if (selectedDataKey) {
    return data?.map(item => item[selectedDataKey])
  }
  return data?.flatMap(item => item.tokens || []);
};


const Histogram = ({ selectedDataKey='', data = []}) => {
  const values = getHistogramValues(selectedDataKey, data);
  if (!values?.length) {
    return (
      <div className="text-sm text-subtle flex items-center justify-center h-full">
        No data available
      </div>
    );
  }

  return (
    <div className="w-full h-full">
      <Plot
        key={values?.length}
        useResizeHandler
        className="w-full h-full"
        data={[
          {
            x: values,
            type: 'histogram',
            marker: { color: '#6366f1' },
            nbinsx: 10
          },
        ]}
        layout={{
          selectedDataKey,
          autosize: true,
          bargap: 0.15,
          font: { family: 'Inter, sans-serif' },
          xaxis: {
            title: selectedDataKey || "Value",
            zeroline: false,
          },
          yaxis: {
            title: 'Frequency',
          },
          margin: { t: 40, l: 40, r: 20, b: 40 },
        }}
        config={{ responsive: true, displayModeBar: false }}
      />
    </div>
  );
};

export default Histogram;